import { ValidOption } from '../../../core/validSvc';
import { IraImportState, IraListPageState } from '../ira_types';
import { validPropDroplistTextVM } from '../../../core/components/validation/ValidInputDroplistText';
import {
    validPropFileVM,
    FILE_SIZE_MAX_MEDIUM,
    FILE_SIZE_MIN_DEFAULT,
} from '../../../core/components/validation/ValidInputFile';

import { IRA_EFFECTIVE_YEAR_START } from '../ira_const';

// PAGE STORE
export function iraListPageStateVM(): IraListPageState {
    return {
        init: false,
        canEdit: false,
        loading: false,
    };
}

// IMPORT
export function iraYearOptions(): ValidOption[] {
    return [
        { lbl: '2026', val: '2026' },
        { lbl: '2027', val: '2027' },
        { lbl: '2028', val: '2028' },
        { lbl: '2029', val: '2029' },
    ];
}

export function iraImportStateVM(): IraImportState {
    return {
        showing: false,
        confirming: false,
        importing: false,
        ContractYear: validPropDroplistTextVM(
            'ContractYear',
            'Choose a Year',
            IRA_EFFECTIVE_YEAR_START,
            IRA_EFFECTIVE_YEAR_START,
            iraYearOptions(),
        ),
        ImportFile: validPropFileVM('File', 'Upload Payor File', ['.csv', '.txt'], {
            min: FILE_SIZE_MIN_DEFAULT,
            max: FILE_SIZE_MAX_MEDIUM,
        }),
    };
}
